// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"6a9708b2","563":"e2ff49e9","804":"040c17c3"}[chunkId] + ".css";
};